






































































import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';
import NewPost from './NewPost.vue';
import { types } from '../../store/types/types.js';
import { parentTypes } from '../../../shared/enums/parentTypes.ts';
import Post from './Post.vue';
import { useUserProfileStore } from '../../../shared/stores';
import { PostModel } from '../../../shared/models/post.model';
import { usePosts } from '../../../shared/composables/usePosts';
import { getCurrentInstance } from 'vue';

export default {
  setup() {
    const { proxy } = getCurrentInstance();
    const { toggleBookmark } = usePosts();
    const handleToggleBookmark = async (post: PostModel) => {
      await toggleBookmark(post);
      const toastMessage = (
        post.isBookmarked ? proxy.$t('post.post_bookmarked') : proxy.$t('post.post_unbookmarked')
      ).toString();
      proxy.$showToast(toastMessage);
    };

    return {
      handleToggleBookmark,
    };
  },
  data: function () {
    return {
      notFoundError: false,
      drawerShow: false,
      postIdToDelete: '',
      editPostId: '',
      reportedContentReason: '',
      showWarningReasonLength: false,
      warningReasonLength: null,
      parent: parentTypes.PROFILE,
      isLoading: true,
    };
  },
  computed: {
    ...mapGetters({
      post: types.GET_SINGLE_POST,
      group: types.GET_ACTIVE_GROUP,
      institutions: types.GET_INSTITUTIONS,
    }),
    userProfileStore() {
      return useUserProfileStore();
    },
    profile() {
      return this.userProfileStore.institutionProfile;
    },
    canViewPost() {
      return this.post.id != null && !this.notFoundError;
    },
  },
  methods: {
    ...mapActions({
      fetchPost: types.ACTION_GET_POST,
      deletePost: types.ACTIONS_DELETE_POST,
      reportPost: types.REPORT_POST,
    }),
    reportPostClicked(postId) {
      const institution = this.institutions.find(
        institution => institution.institutionCode === this.post.ownerProfile.institution.institutionCode
      );
      if (institution?.communicationBlock) {
        this.$refs.blockedCommunicationModal.show();
      } else {
        this.postIdToDelete = postId;
        this.reportedContentReason = '';
        this.showWarningReasonLength = true;
        this.resetCommentForm();
        this.$refs.reportContentModal.show();
      }
    },
    resetCommentForm() {
      this.showWarningReasonLength = false;
      this.warningReasonLength = null;
    },
    saveReportPost() {
      if (this.reportedContentReason.length < 10 || this.reportedContentReason.length > 255) {
        this.showWarningReasonLength = true;
        this.warningReasonLength =
          this.reportedContentReason.length < 10
            ? 'REPORTED_CONTENT_REASON_LENGTH_WARNING_TOO_SHORT'
            : 'REPORTED_CONTENT_REASON_LENGTH_WARNING_TOO_LONG';
      } else {
        this.resetCommentForm();
        this.reportPost({
          id: this.postIdToDelete,
          reportReason: this.reportedContentReason,
        }).then(() => {
          this.$refs.reportContentModal.hide();
          this.reportedContentReason = '';
          this.$router.push({ name: 'overblik' });
        });
      }
    },
    editPost(postId) {
      this.editPostId = postId;
      this.drawerShow = true;
      this.$eventHub.$emit('editPostFromSearch', postId);
    },
    postSubmitted() {
      this.closeDrawer();
      this.handle();
    },
    changeDrawerShow() {
      this.drawerShow = !this.drawerShow;
    },
    closeDrawer() {
      this.drawerShow = false;
      this.editPostId = undefined;
    },
    handle() {
      this.notFoundError = false;
      if (this.$route.params.groupId != null) {
        this.parent = parentTypes.GROUP;
      }
      this.isLoading = true;
      this.fetchPost({
        id: parseInt(this.$route.params.id),
      })
        .catch(() => {
          this.notFoundError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    deletePostButton() {
      this.deletePost({ id: this.postIdToDelete }).then(() => {
        this.$refs.deleteModal.hide();
        this.notFoundError = true;
        this.$router.push({ name: 'overblik' });
      });
    },
    showDeleteModal(id) {
      this.postIdToDelete = id;
      this.$refs.deleteModal.show();
    },
  },
  components: {
    Post,
    NewPost,
  },
  watch: {
    $route(to) {
      if (to.path.includes('/overblik/')) {
        this.handle();
      }
    },
  },
  created() {
    this.handle();
  },
};
